
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"version":"1.2","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 34.5 34.833"}},[_c('path',{attrs:{"fill":"#4C4C4E","d":"M20.891 17.417L32.96 5.348a1.145 1.145 0 000-1.619l-2.023-2.022a1.144 1.144 0 00-1.618 0L17.25 13.776 5.181 1.707a1.144 1.144 0 00-1.618 0L1.54 3.729a1.144 1.144 0 000 1.618l12.069 12.069L1.54 29.486a1.144 1.144 0 000 1.618l2.022 2.022a1.145 1.145 0 001.619 0L17.25 21.058l12.068 12.068a1.145 1.145 0 001.619 0l2.022-2.022a1.144 1.144 0 000-1.618L20.891 17.417z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      